<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <!-- dialog common header -->
      <popup-header v-on:clickClose="closeModal()"></popup-header>
      <v-container>
        <!-- 제목 -->
        <v-row class="title-wrap">
          <v-col cols="12" class="big-title sm-padding pt-0 pb-3"
            >근무기간 선택</v-col
          >
        </v-row>
        <!-- 근무기간선택 리스트 -->
        <v-row class="overflow-y-auto">
          <v-col cols="12" class="px-6 pt-0 pb-5">
            <v-card
              elevation="0"
              class="work-box"
              v-for="item in searchList"
              :key="item.sYmd"
              @click="selectWorkTermItem(item)"
            >
              <v-row class="ma-0 mb-3">
                <v-col cols="12" class="pa-0">
                  <span class="date"
                    ><v-icon color="#087ef7" size="21"
                      >mdi-calendar-range</v-icon
                    >{{ item.termSYmd }} ~ {{ item.termEYmd }}</span
                  >
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="6" class="pa-0"
                  ><v-row class="ma-0"
                    ><v-col cols="12" class="pa-0 label">근무시간</v-col></v-row
                  >
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0 desc">
                      <span class="time"> {{ item.tothour }} </span>시간
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="pa-0 divider"
                  ><v-row class="ma-0">
                    <v-col cols="4" class="pa-0 label">기본</v-col
                    ><v-col cols="8" class="pa-0 text-right desc"
                      ><span class="time"> {{ item.workhour }} </span
                      >시간</v-col
                    >
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="4" class="pa-0 label">연장</v-col
                    ><v-col cols="8" class="pa-0 text-right desc"
                      ><span class="time"> {{ item.othour }} </span>시간
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- 더 보기 버튼 -->
          <v-row align="center" justify="space-around" class="ma-0 mb-8">
            <v-btn
              elevation="0"
              class="btn-more"
              height="38"
              @click="searchMore()"
              v-show="btnShowFlag"
            >
              <span class="black--text">
                <v-icon size="18" class="mt-n1">mdi-chevron-down</v-icon>
                더보기
              </span>
            </v-btn>
          </v-row>
        </v-row>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
/* 근무기간선택 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import { getWorkTermInfoList } from '@/api/workStatus.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import dayjs from 'dayjs';

export default {
  mixins: [dialogMixin],

  data: () => ({
    modalName: 'select_work_term',
    searchList: [],
    btnShowFlag: true,
    currLastSYmd: '',
  }),

  computed: {},

  methods: {
    /* 근무기간 선택 */
    selectWorkTermItem(item) {
      this.$emit('selectWorkTermItem', item);
      this.closeModal();
    },

    /* 더보기 */
    searchMore() {
      // 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      const searchYmd = dayjs(this.currLastSYmd)
        .subtract(1, 'day')
        .format('YYYYMMDD');
      this.fetchWorkTermInfoList(searchYmd, 'off'); // 조회일자 = 마지막 기간시작일자-1일
    },

    /* 근무기간정보 목록조회 */
    async fetchWorkTermInfoList(searchYmd, spinnerFlag) {
      try {
        // 1. 근무기간정보 목록조회 (6건씩 조회, 5건씩 화면출력)
        const response = await getWorkTermInfoList({ searchYmd });
        const dataList = response.data.data;

        // 2. 더보기버튼 비활성화 or 6번째 데이터 삭제
        if (dataList.length <= 5) this.btnShowFlag = false;
        else dataList.pop();

        // 3. 마지막 기간시작일자 저장
        const { length, [length - 1]: lastData } = dataList; // dataList의 마지막 요소 추출 ('lastData'로 사용)
        this.currLastSYmd = lastData.sYmd;

        // 4. 현재 리스트에 조회결과 추가
        this.searchList.push(...dataList);

        // +. 공통 스피너 OFF
        if (spinnerFlag === 'off')
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // +. 공통 스피너 OFF
        if (spinnerFlag === 'off')
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },

  created() {
    const searchYmd = dayjs().format('YYYYMMDD'); // 조회일자 = 현재일자
    this.fetchWorkTermInfoList(searchYmd);
  },

  components: {
    PopupHeader,
  },
};
</script>
